import { render, staticRenderFns } from "./sub-product-list.vue?vue&type=template&id=1fae4464&"
import script from "./sub-product-list.vue?vue&type=script&lang=js&"
export * from "./sub-product-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports